/**
 * Homepage hero copy from Admin → Seasons.
 * Blank fields stay empty so the approved default sentence stays in place.
 */

export type SeasonalHeroFields = {
  hero_badge_text?: string | null;
  hero_title?: string | null;
  hero_description?: string | null;
};

export type SeasonalHeroCopy = {
  badge: string | null;
  title: string | null;
  description: string | null;
};

function blankToNull(value: string | null | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}

export function seasonalHeroCopy(hero: SeasonalHeroFields | null | undefined): SeasonalHeroCopy {
  return {
    badge: blankToNull(hero?.hero_badge_text),
    title: blankToNull(hero?.hero_title),
    description: blankToNull(hero?.hero_description),
  };
}
